"use client";

import React, { useState } from "react";
import { Box, Button, Card, Chip, Grow, Icon, IconButton, LinearProgress, Stack, SwipeableDrawer, Typography } from "@mui/material";
import Arrow2DownIcon from "@/app/_components/Icons/Arrow2DownIcon";
import { Close } from "@mui/icons-material";
import { Color } from "@/__generated__/sdk";
import { useSiteSearchContext } from "./SiteSearchContext";
import _ from "lodash";
function ColorBox({ color, selected, onChange }: { color: Color; selected: boolean; onChange: (id: number) => void }) {
  return (
    <Box
      onClick={() => {
        onChange(color.id);
      }}
      sx={(t) => {
        return {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
          borderRadius: 2,
          boxSizing: "border-box",
          boxShadow: `inset 0 0 ${selected ? 3 : 1}px 1px ${selected ? t.palette.secondary.main : t.palette.grey["100"]}`,
          gap: 0.5,
          p: 0.5,
          pr: 0.5,
          transition: "0.2s all",
          cursor: "pointer",
        };
      }}
    >
      <Card
        elevation={0}
        sx={{
          borderRadius: 2,
          width: 26,
          height: 26,
          background: color.hex,
        }}
      ></Card>
      <Typography variant="body2">{color.title}</Typography>
    </Box>
  );
}

function ColorsList({ handleClose }: { handleClose: () => void }) {
  const { isPending, colors, selectedColors, handleColorsChange } = useSiteSearchContext();
  const [selected, setSelected] = useState<number[] | undefined>(selectedColors);
  const hasSelectedColors = Boolean(selectedColors && selectedColors?.length > 0);

  return (
    <>
      <Box sx={{ display: "flex", p: 2, overflowY: "auto", flexGrow: 1, alignItems: "start" }}>
        <Stack spacing={{ xs: 1.3, sm: 2 }} direction="row" useFlexGap sx={{ flexWrap: "wrap" }}>
          {colors &&
            colors.map((color, index) => {
              const isSelected = Boolean(selected && selected.includes(color.id));
              return (
                <ColorBox
                  key={index}
                  color={color}
                  selected={isSelected}
                  onChange={(id) => {
                    let newValues: number[] | null | undefined = selected;

                    if (isSelected) {
                      if (newValues && newValues.includes(id)) {
                        const indexColorToRemove = newValues.findIndex((a) => a === id);
                        if (indexColorToRemove > -1) {
                          newValues.splice(indexColorToRemove, 1);
                        }
                      }
                    } else {
                      if (newValues) {
                        newValues.push(id);
                      } else {
                        newValues = [id];
                      }
                    }

                    if (!newValues || newValues.length <= 0) {
                      newValues = undefined;
                    }

                    setSelected(_.uniq(newValues));
                  }}
                ></ColorBox>
              );
            })}
        </Stack>
      </Box>
      <Box
        sx={{
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: hasSelectedColors ? "space-between" : "end",
          gap: 1,
          p: 2,
        }}
      >
        {hasSelectedColors && (
          <Button
            variant="outlined"
            onClick={() => {
              handleColorsChange(undefined);
              handleClose();
            }}
            disableElevation
            sx={{ borderRadius: 2 }}
            startIcon={<Close />}
          >
            حذف فیلتر
          </Button>
        )}
        <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "end", gap: 1 }}>
          <Button
            onClick={() => {
              handleClose();
            }}
          >
            انصراف
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleColorsChange(selected);
              handleClose();
            }}
            disableElevation
            sx={{ borderRadius: 2 }}
          >
            اعمال فیلر
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default function MobileFilterColorChip() {
  const { isPending, colors, selectedColors, handleColorsChange } = useSiteSearchContext();
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const hasSelectedColors = Boolean(selectedColors && selectedColors?.length > 0);
  return (
    <>
      <Chip
        variant={hasSelectedColors ? "filled" : "outlined"}
        onClick={() => {
          setOpen(true);
        }}
        {...(hasSelectedColors && {
          color: "primary",
          onDelete: () => {
            handleColorsChange(undefined);
          },
        })}
        label={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* <Icon sx={{ fontSize: 14 }}>
              <SortIcon />
            </Icon> */}
            <Typography variant="body2">رنگ</Typography>
            {/* <Icon sx={{ fontSize: 14 }}>
              <Arrow2DownIcon />
            </Icon> */}
          </Box>
        }
      ></Chip>

      <SwipeableDrawer
        ModalProps={{
          keepMounted: false,
        }}
        PaperProps={{
          sx: {
            height: "70vh",
            borderTopLeftRadius: 4 * 4,
            borderTopRightRadius: 4 * 4,
          },
        }}
        anchor={"bottom"}
        open={open}
        onClose={() => {
          handleClose();
        }}
        onOpen={() => {}}
        disableDiscovery={true}
        hysteresis={0}
        disableSwipeToOpen={true}
        swipeAreaWidth={0}
      >
        <Stack sx={{ height: "100%", flexGrow: 1 }}>
          <Stack sx={{ flexShrink: 0 }}>
            <Grow in={isPending}>
              <LinearProgress variant="indeterminate" color="secondary" />
            </Grow>
          </Stack>
          <Stack direction={"row"} sx={{ mt: 1, flexShrink: 0 }} alignItems={"center"} justifyContent={"center"}>
            <Box width={"45px"} height={"5px"} sx={{ borderRadius: 50, backgroundColor: "grey.100" }}></Box>
          </Stack>
          <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "space-between", p: 2 }}>
            <Typography variant="h4"> فیلتر رنگ </Typography>
            <IconButton
              onClick={() => {
                handleClose();
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <ColorsList handleClose={handleClose} />
        </Stack>
      </SwipeableDrawer>
    </>
  );
}
